import moment from "moment";

class RelativeTimeFilter {
    constructor() {
        return date => {
            return moment(date).fromNow();
        };
    }
}

angular
    .module("thor.core.dates.relativeTime.filter", [])
    .filter("relativeTime", <any>RelativeTimeFilter);
